import styled from "@emotion/styled";

export const Container = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  height: 46px;
  padding: 0 20px;

  img {
    justify-self: start;
  }

  div {
    justify-self: center;
  }
`;

export const Line = styled.div`
  height: 1px;
  background-color: #E4E4E7;
`;